import React, { useState } from "react";
import styles from "./vtrg_split_screen.scss";
import { useForm } from "react-hook-form";
import { Editor } from "@tinymce/tinymce-react";
import axios from "axios";

import { request } from "../../../api";
import cancelPieceForm from "../cancel_piece_form";
import ImagePreview from "../../components/edit/ImagePreview";
import ImageDropzone from "../../components/edit/ImageDropzone";

const VtrgSplitScreenForm = ({
  data,
  instanceType,
  instanceId,
  pieceType,
  slot,
  updatePiece,
  setActionLoading,
  ordn,
  afterUpdateVtrgPiece,
  getPieceForm,
}) => {
  const [successMsg, setSuccessMsg] = useState(null);
  const [errorMsg, setErrorMsg] = useState(null);
  const [disableBtns, setDisableBtns] = useState(false);
  const [values, setValues] = useState({
    lback: data && data.lback ? data.lback : "",
    limage: data && data.limage ? data.limage : "",
    lbody: data && data.lbody ? data.lbody : "",
    lpadding: data && data.lpadding ? data.lpadding : "",
    lmargin: data && data.lmargin ? data.lmargin : "",
    lfree_style:
      data && data.lfree_style && data.lfree_style ? data.lfree_style : "",
    rback: data && data.rback ? data.rback : "",
    rimage: data && data.rimage ? data.rimage : "",
    rbody: data && data.rbody ? data.rbody : "",
    rpadding: data && data.rpadding ? data.rpadding : "",
    rmargin: data && data.rmargin ? data.rmargin : "",
    rfree_style: data && data.rfree_style ? data.rfree_style : "",
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const updatedTime =
    data && data.updated_at ? new Date(data.updated_at).getTime() : 0;

  const onSubmit = (localData, e) => {
    setDisableBtns(true);
    if (ordn) {
      setActionLoading(ordn);
    }

    const dataForm = new FormData();

    Object.keys(localData)
      .filter((key) => key in values)
      .forEach((key) => (localData[key] = values[key]));

    Object.entries(values).map((item) => {
      if (
        (item[0] === "limage" && item[1].constructor === File) ||
        (item[0] === "rimage" && item[1].constructor === File) ||
        (item[0] != "limage" && item[0] != "rimage")
      ) {
        dataForm.set(item[0], item[1]);
       }
    });
    dataForm.append("kind", pieceType);
    dataForm.append("owner_type", instanceType);
    dataForm.append("owner_id", instanceId);
    dataForm.append("id", data && data.id);

    axios
      .post(`${request}/vitrage/pieces/${slot ? slot : "new"}`, dataForm)
      .then((response) => {
        if (response.statusText === "OK") {
          setSuccessMsg("Изменения успешно внесены");
          if (!slot && response.data.content) {
            getPieceForm(null);
            afterUpdateVtrgPiece(response.data.content);
          } else {
            // Берём данные из ответа сервера: в localData изображения — это File без url
            afterUpdateVtrgPiece(
              response?.data?.data?.content
                ? response.data.data.content
                : localData,
            );
          }
        } else {
          setErrorMsg("Произошли ошибки, пожалуйста попробуйте позже.");
        }
      })
      .catch((error) => {
        console.log(error);
        setErrorMsg("Произошли ошибки, пожалуйста попробуйте позже.");
      })
      .finally(() => {
        setDisableBtns(false);
        setTimeout(() => {
          setSuccessMsg(null);
          setErrorMsg(null);
          updatePiece(null);
          setActionLoading(null);
        }, 500);
      });
  };

  const onError = (errors, e) => {
    console.log(errors);
    setErrorMsg("Произошла ошибка");
  };

  return (
    <div className="vtrg-edit-body">
      <h3>блок из двух половинок:</h3>
      <form
        onSubmit={handleSubmit(onSubmit, onError)}
        noValidate="novalidate"
        className="vitrage_pieces_vtrg_centered_image"
        encType="multipart/form-data"
        action={`${request}/vitrage/pieces/${data ? data.id : "new"}}`}
        accept-charset="UTF-8"
        data-remote="true"
        method="post"
      >
        <div className="inputs-wrap">
          <legend>Левая половинка</legend>

          <fieldset className="inputs">
            <label>Цвет фона</label>
            <input
              type="color"
              placeholder="#FFF"
              defaultValue={data && data.lback ? data.lback : ""}
              {...register("lback", { value: values.lback })}
              onChange={(e) => {
                setValues((values) => {
                  values.lback = e.target.value;
                  return values;
                });
              }}
            />
          </fieldset>

          <fieldset className="inputs">
            <label>Изображение в половинке</label>
            <ImageDropzone
              name="limage"
              onChange={(files) =>
                setValues((prev) => ({ ...prev, limage: files[0] }))
              }
            />
            <ImagePreview image={values.limage} version={updatedTime} />

          </fieldset>

          <fieldset className="inputs">
            <label>Содержание</label>
            <Editor
              id="vitrage_pieces_vtrg_split_screen_lbody"
              apiKey="d67jsxjoo87h4ff009q4p3uxwvoxl1k4ptvjr6l5qxfplr03"
              cloudChannel="dev"
              init={{
                plugins: "paste",
                paste_preprocess: function (_, args) {
                  args.content = args.content.replace(/&amp;/g, "&");
                },
              }}
              {...register("lbody", { value: values.lbody })}
              initialValue={data && data.lbody}
              onEditorChange={(newText) => {
                setValues((values) => {
                  values.lbody = newText;
                  return values;
                });
              }}
            />
            <p className="inline-hints">
              Содержание будет отображаться только если изображение не задано
            </p>
          </fieldset>

          <fieldset className="inputs">
            <label>Отступы(padding)</label>
            <input
              type="text"
              placeholder="0px 0px 0px 0px"
              defaultValue={data && data.lpadding ? data.lpadding : ""}
              {...register("lpadding", { value: values.lpadding })}
              onChange={(e) => {
                setValues((values) => {
                  values.lpadding = e.target.value;
                  return values;
                });
              }}
            />
            <p className="inline-hints">
              Отступы задаются в порядке: сверху, справа, снизу, слева!
            </p>
          </fieldset>

          <fieldset className="inputs">
            <label>Отступы(margin)</label>
            <input
              type="text"
              defaultValue={data && data.lmargin ? data.lmargin : ""}
              {...register("lmargin", { value: values.lmargin })}
              onChange={(e) => {
                setValues((values) => {
                  values.lmargin = e.target.value;
                  return values;
                });
              }}
              placeholder="0px 0px 0px 0px"
            />
            <p className="inline-hints">
              Отступы задаются в порядке: сверху, справа, снизу, слева!
            </p>
          </fieldset>

          <fieldset className="inputs">
            <label>CSS-код для блока</label>
            <input
              type="text"
              placeholder="0"
              defaultValue={data && data.lfree_style ? data.lfree_style : ""}
              {...register("lfree_style", { value: values.lfree_style })}
              onChange={(e) => {
                setValues((values) => {
                  values.lfree_style = e.target.value;
                  return values;
                });
              }}
            />
            <p className="inline-hints">
              ОСТОРОЖНО!!! Только для тех кто знает CSS! Помним что код,
              заданный в этом поле, будет приоритетнее предыдущего
            </p>
          </fieldset>
        </div>

        <div className="inputs-wrap">
          <legend>Правая половинка</legend>
          <fieldset className="inputs">
            <label>Цвет фона</label>
            <input
              type="color"
              placeholder="#FFF"
              defaultValue={data && data.rback ? data.rback : ""}
              {...register("rback", { value: values.rback })}
              onChange={(e) => {
                setValues((values) => {
                  values.rback = e.target.value;
                  return values;
                });
              }}
            />
          </fieldset>

          <fieldset className="inputs">
            <label>Изображение в половинке</label>
            <ImageDropzone
              name="rimage"
              onChange={(files) =>
                setValues((prev) => ({ ...prev, rimage: files[0] }))
              }
            />
            <ImagePreview image={values.rimage} version={updatedTime} />

          </fieldset>

          <fieldset className="inputs">
            <label>Содержание</label>
            <Editor
              id="vitrage_pieces_vtrg_split_screen_rbody"
              apiKey="d67jsxjoo87h4ff009q4p3uxwvoxl1k4ptvjr6l5qxfplr03"
              cloudChannel="dev"
              init={{
                plugins: "paste",
                paste_preprocess: function (_, args) {
                  args.content = args.content.replace(/&amp;/g, "&");
                },
              }}
              {...register("rbody", { value: values.rbody })}
              initialValue={data && data.rbody}
              onEditorChange={(newText) => {
                setValues((values) => {
                  values.rbody = newText;
                  return values;
                });
              }}
            />
            <p className="inline-hints">
              Содержание будет отображаться только если изображение не задано
            </p>
          </fieldset>

          <fieldset className="inputs">
            <label>Отступы(padding)</label>
            <input
              type="text"
              placeholder="0px 0px 0px 0px"
              defaultValue={values && values.rpadding ? values.rpadding : ""}
              {...register("rpadding", { value: values.rpadding })}
              onChange={(e) => {
                setValues((values) => {
                  values.rpadding = e.target.value;
                  return values;
                });
              }}
            />

            <p className="inline-hints">
              Отступы задаются в порядке: сверху, справа, снизу, слева!
            </p>
          </fieldset>

          <fieldset className="inputs">
            <label>Отступы(margin)</label>
            <input
              type="text"
              placeholder="0px 0px 0px 0px"
              defaultValue={values && values.rmargin ? values.rmargin : ""}
              {...register("lpadding", { value: values.rmargin })}
              onChange={(e) => {
                setValues((values) => {
                  values.rmargin = e.target.value;
                  return values;
                });
              }}
            />

            <p className="inline-hints">
              Отступы задаются в порядке: сверху, справа, снизу, слева!
            </p>
          </fieldset>

          <fieldset className="inputs">
            <label>CSS-код для блока</label>
            <input
              type="text"
              placeholder="0"
              defaultValue={
                values && values.rfree_style ? values.rfree_style : ""
              }
              {...register("rfree_style", { value: values.rfree_style })}
              onChange={(e) => {
                setValues((values) => {
                  values.rfree_style = e.target.value;
                  return values;
                });
              }}
            />

            <p className="inline-hints">
              ОСТОРОЖНО!!! Только для тех кто знает CSS! Помним что код,
              заданный в этом поле, будет приоритетнее предыдущего
            </p>
          </fieldset>
        </div>

        <input
          type="hidden"
          name="kind"
          value={pieceType}
          {...register("kind", { value: pieceType })}
        />
        <input
          type="hidden"
          name="owner_type"
          value={instanceType}
          {...register("owner_type", { value: instanceType })}
        />
        <input
          type="hidden"
          name="owner_id"
          value={instanceId}
          {...register("owner_id", { value: instanceId })}
        />

        {successMsg && <p className="success-hint">{successMsg}</p>}
        {errorMsg && <p className="error-hint">{errorMsg}</p>}
        {disableBtns && <span className="loading-hint"> Подождите ... </span>}

        <fieldset className={disableBtns ? "actions_disable" : "actions"}>
          <input type="submit" />
          <input
            type="reset"
            value="Отмена"
            onClick={() =>
              cancelPieceForm({ slot, updatePiece, afterUpdateVtrgPiece, getPieceForm })
            }
          />
        </fieldset>
      </form>
    </div>
  );
};

export default VtrgSplitScreenForm;
